import { Button } from "ui/button";

import { usePublishTheme } from "containers/admin/clients/client/theme-configuration-page/components/publish-button/use-publish-theme";

type PublishButtonProps = { disabled: boolean };

/** Sends the saved theme to BEE; what is only being edited is not published until it is saved. */
export const PublishButton = ({ disabled }: PublishButtonProps) => {
  const { isPublishDisabled, isPublishing, handlePublish } = usePublishTheme();

  return (
    <Button
      size="large"
      loading={isPublishing}
      disabled={disabled || isPublishDisabled || isPublishing}
      onClick={handlePublish}>
      Publish
    </Button>
  );
};
